<template>
  <div v-if="$route.name === 'homepage'" class="package-type-switch">
    <button
      v-for="package_type_option in package_type_options"
      :key="package_type_option.value"
      :class="`package-type-switch--button ${
        package_type_option.value === package_type ? 'active' : ''
      }`"
      @click="() => select_package_type(package_type_option.value)"
    >
      {{ package_type_option.label }}
    </button>
  </div>
</template>

<script>
import { PACKAGE_TYPES } from "@alpitour/resources"; 
import { alpitour_rybbit_event } from "@alpitour/utilities/rybbit";
import { are_services_present } from "@/services";

const only_stay_package_services = [
  "keyds",
  "keydsMap",
  "search",
  "details",
  "quote",
].map(base => `sololand.${base}`)

export default {
  name: "package-type-switch",

  props: {},

  data() {
    return {
      package_type_options: [
        {
          label: "Volo e soggiorno",
          value: PACKAGE_TYPES.FLIGHT_AND_STAY,
        },
        {
          label: "Solo soggiorno",
          value: PACKAGE_TYPES.ONLY_STAY,
        },
      ],
    };
  },

  mounted() {

    const allowed_package_types = this.get_allowed_package_types().reduce(
      (map, key) => {
        map[key] = true;
        return map;
      },
      {},
    );
    this.package_type_options = this.package_type_options.filter(
      (option) => allowed_package_types[option.value],
    );
    if (!allowed_package_types[this.package_type]) {
      this.package_type = this.package_type_options[0].value;
    }
  },

  computed: {

    package_type: {
      get() {
        return this.$store.state.liveat.package_type;
      },
      set(value) {
        this.$store.commit("liveat/package_type", value);
      },
    },
  },

  methods: {
    select_package_type(value) {
      if (this.package_type === value) {
        return;
      }
      this.package_type = value;
      this.$emit("change:package_type", value);
      alpitour_rybbit_event("package:type:select", {
        selected_type: value,
      });
    },
    get_allowed_package_types() {
      const allowed_package_types = [PACKAGE_TYPES.FLIGHT_AND_STAY]
      // If endpoints for the only-stay flow are present enable it
      if (are_services_present(only_stay_package_services)) {
        allowed_package_types.push(PACKAGE_TYPES.ONLY_STAY);
      }
      return allowed_package_types;
    },

  },
};
</script>

<style lang="scss" scoped>

  .package-type-switch {
    border-radius: 10px 10px 0 0;
    margin-bottom: -1px;
    z-index: 0;
    background-color: $extra2;
    display: inline-block;
    border: 1px solid rgba(255,255,255, .6);

    @include media-breakpoint-up(xl) {
      margin-left: -($grid-gutter-width / 2);
    }

    &--button {
      padding: ($grid-gutter-width / 3) ($grid-gutter-20 * 2);
      color: $gray-500;
      font-weight: $vb-font-weight-semibold;
      background: transparent;
      border: none;

      &:hover {
        color: $info;
      }

      &.active {
        background-color: $extra2;
        color: $primary;
        border: 1px solid $white;
        border-radius: 10px 10px 0 0;

        &:first-child {
          box-shadow: 3px 0 4px 0 rgba(0,0,0, .06)
        }

        &:last-child {
          box-shadow: -3px 0 4px 0 rgba(0,0,0, .06)
        }
      }
    }
  }

</style>
